module.exports = __webpack_public_path__ + "c926976f8404e2f54f0fa9072b249ba7.pdf";